"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
const LaravelAPIPaginator_1 = __importDefault(require("@common/tsutils/LaravelAPIPaginator"));
const Sample_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Sample"));
const SelectableSampleList_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/SelectableSampleList"));
const Filter_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Filter"));
const label_functions_1 = require("@becrop/components/Toolkit/Heatmap2/models/options/label_functions");
const GroupConfig_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/GroupConfig"));
const Group_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Group"));
const HeatmapRanks_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/HeatmapRanks"));
const OrderConfig_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/OrderConfig"));
const GroupConfigInstance_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/GroupConfigInstance"));
const OrderConfigInstance_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/OrderConfigInstance"));
const downloadFile_1 = __importDefault(require("@common/tsutils/downloadFile"));
const SVGString2Image_1 = __importDefault(require("@common/tsutils/SVGString2Image"));
const Configuration_1 = require("@becrop/components/Toolkit/Heatmap2/models/Configuration");
class Heatmap {
    constructor() {
        // Flag for loaded samples from the server
        this.loaded_samples = false;
        // Flag for library filtered
        this.filtered_samples = false;
        // Flag for library searched
        this.filtered_samples2 = false;
        // Flag for selection searched
        this.filtered_selection = true;
        // Flag for triggering a refresh
        this.need_refresh = false;
        //
        this.selectedElement = 'bio';
        this.selectedFocus = 'samples';
        this.modifiedZoom = false;
        // This is the full list of samples
        this.librarySamples = new SelectableSampleList_1.default();
        // This is the list after the filters
        this.filteredLibrarySamples = new SelectableSampleList_1.default();
        // This is the list with the text filter
        this.filteredLibrarySamples2 = new SelectableSampleList_1.default();
        // Full selected sample list
        this.selectedSamples = new SelectableSampleList_1.default();
        // Full selected sample list
        this.filteredSelectedSamples = new SelectableSampleList_1.default();
        // The last samples added
        this.lastSamples = [];
        this.manualArranged = false;
        this.groupConfigInstance1 = null;
        this.groupConfigInstance2 = null;
        this.orderConfigInstance = null;
        this.root = null;
        this.csv = null;
        this.coreFilters = [
            Filter_1.default.newList('soil_type', 'soil_type_id', label_functions_1.soil_type_label_fn),
            Filter_1.default.newNumber('plant_year', 'plant_year'),
            Filter_1.default.newDate('coll_date', 'date'),
            Filter_1.default.newBoolean('org_practises', 'org_practises'),
            Filter_1.default.newBoolean('art_irrigation', 'art_irrigation'),
            Filter_1.default.newBoolean('bio_methods', 'bio_methods'),
            Filter_1.default.newNumber('density', 'density'),
            Filter_1.default.newList('variety', 'variety'),
            Filter_1.default.newList('parcel', 'parcel_name'),
        ];
        this.coreGroupConfigs = [
            GroupConfig_1.default.newCoreList('soil_type', 'soil_type_id', label_functions_1.soil_type_label_fn),
            GroupConfig_1.default.newCoreNumber('plant_year', 'plant_year'),
            GroupConfig_1.default.newCoreDate('coll_date', 'date'),
            GroupConfig_1.default.newCoreBoolean('org_practises', 'org_practises'),
            GroupConfig_1.default.newCoreBoolean('art_irrigation', 'art_irrigation'),
            GroupConfig_1.default.newCoreBoolean('bio_methods', 'bio_methods'),
            GroupConfig_1.default.newCoreNumber('density', 'density'),
            GroupConfig_1.default.newCoreList('variety', 'variety'),
            GroupConfig_1.default.newCoreList('parcel', 'parcel_name'),
        ];
        this.coreOrderConfigs = [
            OrderConfig_1.default.newList('soil_type', 'soil_type_id'),
            OrderConfig_1.default.newNumber('plant_year', 'plant_year'),
            OrderConfig_1.default.newDate('coll_date', 'date'),
            OrderConfig_1.default.newBoolean('org_practises', 'org_practises'),
            OrderConfig_1.default.newBoolean('art_irrigation', 'art_irrigation'),
            OrderConfig_1.default.newBoolean('bio_methods', 'bio_methods'),
            OrderConfig_1.default.newNumber('density', 'density'),
            OrderConfig_1.default.newList('variety', 'variety'),
            OrderConfig_1.default.newList('parcel', 'parcel_name'),
        ];
        this.csvFilters = [];
        this.csvGroupConfigs = [];
        this.csvOrderConfigs = [];
        this.ranksFilters = []; // TODO
        this.ranksGroupConfigs = []; // TODO
        this.ranksOrderConfigs = []; // TODO
        this.activeElement = null;
        // General options
        this.optionOrientation = 'horizontal';
        this.optionDisplay = 'code';
        this.download_idx = 0;
        this.download_svg = null;
    }
    availableFilters() {
        return [
            ...this.coreFilters,
            ...this.csvFilters,
        ];
    }
    availableGroupConfigs() {
        //console.log("get availableGroupConfigs");
        const samples = this.selectedSamples.samples.map(x => x.sample);
        let configs = [
            ...this.coreGroupConfigs,
            ...this.csvGroupConfigs,
        ];
        configs.forEach(config => {
            config.update(samples);
        });
        return configs;
    }
    availableOrderConfigs() {
        const samples = this.selectedSamples.samples.map(x => x.sample);
        let configs = [
            ...this.coreOrderConfigs,
            ...this.csvOrderConfigs,
        ];
        configs.forEach(config => {
            config.update(samples);
        });
        return configs;
    }
    addSelection(samples) {
        this.selectedSamples.add(samples);
        this.filteredSelectedSamples = this.selectedSamples;
        this.lastSamples = samples;
    }
    undoLastAdd() {
        this.lastSamples.forEach(s => this.rmSample(s));
        this.filteredSelectedSamples = this.selectedSamples;
    }
    rmAll() {
        const samples = this.selectedSamples.samples.map(ss => ss.sample);
        samples.forEach(s => this.rmSample(s));
        this.filteredSelectedSamples = this.selectedSamples;
        this.root = null;
        this.activeElement = null;
        this.removeCSV();
    }
    empty() {
        return this.selectedSamples.length === 0;
    }
    rmSample(sample) {
        if (sample.alchemy_samples) {
            sample.alchemy_samples.forEach(s => this.rmSample(s));
        }
        const ss = this.librarySamples.find(sample);
        if (ss) {
            ss.selected = false;
            ss.disabled = false;
        }
        this.selectedSamples.rm(sample);
        this.filteredSelectedSamples.rm(sample);
        this.lastSamples = [];
    }
    async loadSamples() {
        await (0, sleep_1.default)(1000);
        const url = '/toolkit/heatmap/api/samples';
        const paginator = LaravelAPIPaginator_1.default.get(url);
        const items = await paginator.all();
        // Transform the raw items into typescript classes
        const library = items.map((raw) => Sample_1.default.fromRaw(raw));
        this.librarySamples = new SelectableSampleList_1.default(library);
        this.loaded_samples = true;
        this.initEnabledFilters();
        await this.filterLibrary();
        // TODO: This is used to add some samples at the beginning
        /*
        const demos = this.librarySamples.samples.slice(0,12);
        demos.forEach(d => d.disabled = true);
        this.addSelection(demos.map(d => d.sample));
        */
    }
    async filterLibrary(filters = []) {
        this.filtered_samples = false;
        this.filtered_samples2 = false;
        await (0, sleep_1.default)(1000);
        if (!filters.length) {
            this.filteredLibrarySamples = this.librarySamples;
            this.filteredLibrarySamples2 = this.librarySamples;
            this.filtered_samples = true;
            this.filtered_samples2 = true;
            return;
        }
        this.filteredLibrarySamples = await this.librarySamples.asyncFilter(filters);
        this.filteredLibrarySamples2 = this.filteredLibrarySamples;
        this.filtered_samples = true;
        this.filtered_samples2 = true;
    }
    async filterLibraryText(text) {
        this.filtered_samples2 = false;
        await (0, sleep_1.default)(1000);
        if (!text.trim().length) {
            this.filteredLibrarySamples2 = this.librarySamples;
            this.filtered_samples2 = true;
            return;
        }
        this.filteredLibrarySamples2 = await this.filteredLibrarySamples.asyncFilterText(text.trim());
        this.filtered_samples2 = true;
    }
    async filterSelectionText(text) {
        this.filtered_selection = false;
        await (0, sleep_1.default)(1000);
        if (!text.trim().length) {
            this.filteredSelectedSamples = this.selectedSamples;
            this.filtered_selection = true;
            return;
        }
        this.filteredSelectedSamples = await this.selectedSamples.asyncFilterText(text.trim());
        this.filtered_selection = true;
    }
    initEnabledFilters() {
        const library = this.librarySamples.samples.map(s => s.sample);
        for (const f of this.coreFilters) {
            f.initFilter(library);
        }
        for (const f of this.csvFilters) {
            f.initFilter(library);
        }
    }
    setGroupConfig(config1 = null, config2 = null) {
        console.log("Set groups", config1 === null || config1 === void 0 ? void 0 : config1.config.name, config2 === null || config2 === void 0 ? void 0 : config2.config.name);
        this.groupConfigInstance1 = config1;
        this.groupConfigInstance2 = config2;
    }
    setOrderConfig(config = null) {
        console.log("Set order in heatmap");
        this.orderConfigInstance = config;
    }
    buildGroups() {
        const grouping1 = this.groupConfigInstance1;
        const grouping2 = this.groupConfigInstance2;
        const root = new Group_1.default('root');
        let samples = this.selectedSamples.samples.map(x => x.sample);
        if (grouping1) {
            root.groups = grouping1.group(samples, root);
            root.groupConfigInstance = grouping1;
            if (grouping2) {
                root.groups.forEach(group => {
                    group.groups = grouping2.group(group.samples, group);
                    group.groupConfigInstance = grouping2;
                    group.samples = null;
                });
            }
        }
        else {
            root.samples = samples;
        }
        this.root = root;
        this.orderSamplesInFinalGroups();
    }
    orderSamplesInFinalGroups() {
        function traverseGroup(group, sorting) {
            if (group.samples) {
                if (sorting)
                    group.samples = sorting.sortSamples(group.samples);
                group.orderConfigInstance = sorting;
                return;
            }
            if (group.groups) {
                group.groups.forEach(g => traverseGroup(g, sorting));
            }
        }
        if (!this.root) {
            console.warn("Heatmap root group does not exists");
            return;
        }
        traverseGroup(this.root, this.orderConfigInstance);
    }
    getHeatmapRanks() {
        return HeatmapRanks_1.default.build(this.root, this.selectedElement);
    }
    async download() {
        this.download_svg = null;
        this.download_idx++;
        while (!this.download_svg) {
            await (0, sleep_1.default)(1000);
        }
        const dsvg = this.download_svg;
        const pngBlob = await (0, SVGString2Image_1.default)(dsvg.content, dsvg.width, dsvg.height);
        (0, downloadFile_1.default)(pngBlob, 'heatmap.png', 'image/png');
    }
    toConfiguration() {
        var _a, _b, _c;
        return {
            version: 1,
            group1: (_a = this.groupConfigInstance1) === null || _a === void 0 ? void 0 : _a.toConfiguration(),
            group2: (_b = this.groupConfigInstance2) === null || _b === void 0 ? void 0 : _b.toConfiguration(),
            order: (_c = this.orderConfigInstance) === null || _c === void 0 ? void 0 : _c.toConfiguration(),
            root: this.root.toConfiguration(),
            element: this.selectedElement,
        };
    }
    async fromConfiguration(configuration) {
        var _a, _b, _c;
        console.log(configuration);
        //
        // Reset library samples
        //
        this.rmAll();
        await (0, sleep_1.default)(100);
        //
        // Select samples in the config
        //
        const codes = (0, Configuration_1.getSamplesRecursive)(configuration.data.root).map(s => s.code);
        const samples = [];
        for (const code of codes) {
            const sample = this.librarySamples.findByCode(code);
            if (sample)
                samples.push(sample.sample);
        }
        this.addSelection(samples);
        await (0, sleep_1.default)(200);
        //
        // Groups
        //
        const createGroupConfigInstance = (gcic) => {
            if (!gcic)
                return null;
            const groupConfig = this.availableGroupConfigs().find(gc => gc.name === gcic.config_name);
            const groupConfigInstance = new GroupConfigInstance_1.default(groupConfig);
            groupConfigInstance.num_of_groups = gcic.num_of_groups;
            groupConfigInstance.direction = gcic.direction;
            return groupConfigInstance;
        };
        this.groupConfigInstance1 = createGroupConfigInstance((_a = configuration.data) === null || _a === void 0 ? void 0 : _a.group1);
        await (0, sleep_1.default)(50);
        this.groupConfigInstance2 = createGroupConfigInstance((_b = configuration.data) === null || _b === void 0 ? void 0 : _b.group2);
        console.log("Chaing group Config isntances", this.groupConfigInstance1, this.groupConfigInstance2);
        console.log(configuration.data);
        //
        // Sort
        //
        const createOrderConfigInstance = (ocic) => {
            if (!ocic)
                return null;
            const orderConfig = this.availableOrderConfigs().find(gc => gc.name === ocic.config_name);
            const orderConfigInstance = new OrderConfigInstance_1.default(orderConfig);
            orderConfigInstance.direction = ocic.direction;
            return orderConfigInstance;
        };
        this.orderConfigInstance = createOrderConfigInstance((_c = configuration.data) === null || _c === void 0 ? void 0 : _c.order);
        console.warn("new order from configuration", configuration.data, this.orderConfigInstance);
        await (0, sleep_1.default)(1000);
        //
        // Build the root group
        //
        const root = new Group_1.default('root');
        this.buildGroupsFromConfiguration(configuration.data.root, root);
        this.root = root;
        this.selectedElement = '';
        await (0, sleep_1.default)(100);
        this.selectedElement = configuration.data.element || 'all';
    }
    buildGroupsFromConfiguration(groupConfiguration, parent) {
        if (groupConfiguration.samples) {
            const samples = [];
            for (const code of groupConfiguration.samples.map(s => s.code)) {
                const sample = this.librarySamples.findByCode(code);
                if (sample)
                    samples.push(sample.sample);
            }
            parent.samples = samples;
            return;
        }
        if (groupConfiguration.groups) {
            parent.groups = [];
            groupConfiguration.groups.forEach(subGroupConfiguration => {
                const subGroup = new Group_1.default(subGroupConfiguration.name, parent);
                subGroup.color = subGroupConfiguration.color;
                this.buildGroupsFromConfiguration(subGroupConfiguration, subGroup);
                parent.groups.push(subGroup);
            });
            return;
        }
    }
    importCSVMetadata(csv) {
        const fields = csv.getFields();
        this.librarySamples.samples.forEach(s => {
            s.sample.csvMetadata.reset();
        });
        const samples = csv.codes
            .map(c => { var _a; return (_a = this.librarySamples.findByCode(c)) === null || _a === void 0 ? void 0 : _a.sample; });
        fields.forEach(field => {
            const parsedData = field.parseData();
            samples.forEach((sample, i) => {
                if (!sample)
                    return;
                sample.addCSVMetadatata(field.id, parsedData[i]);
            });
        });
        this.csvFilters = [];
        this.csvGroupConfigs = [];
        this.csvOrderConfigs = [];
        fields.forEach(field => {
            //let items = undefined;
            const filter = Filter_1.default.newFilterFromMetadata(field.type, field.id, field.name);
            this.csvFilters.push(filter);
            const group = GroupConfig_1.default.newCSV(field.type, field.id, field.name);
            this.csvGroupConfigs.push(group);
            const order = OrderConfig_1.default.newOrderFromMetadata(field.type, field.id, field.name);
            this.csvOrderConfigs.push(order);
        });
        this.initEnabledFilters();
        this.csv = csv;
    }
    removeCSV() {
        this.csv = null;
    }
    hasAlchemy() {
        return this.selectedSamples.samples.some(s => s.sample.alchemy);
    }
}
exports.default = Heatmap;
// Constants
Heatmap.PRE_MAX_SAMPLES = 100;
Heatmap.SEL_MAX_SAMPLES = 100;
